// extracted by mini-css-extract-plugin
export default {"error-message":"f6h79Va59cEMnA_35Bzc"};